import { Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import SimpleCard from '../../../../../components/SimpleCard';
import { formatTime } from '../../../../../utils';
import CheckIcon from '../../../vendor-event-guide/components/CheckIcon';

export default function SuccessPage() {
  const {
    events: { event },
    vendorEvents: { currentVendorEvent },
  } = useSelector((store) => store);

  return (
    <div>
      <Grid container justifyContent="center" marginY={2}>
        <CheckIcon checked={currentVendorEvent?.status === 'paid'} />
        <Typography>You are already registered for this event</Typography>
      </Grid>
      <Grid container justifyContent="center">
        <Grid item>
          <Typography fontWeight="bold">Reminders:</Typography>
        </Grid>
        <Grid item>
          <Typography marginLeft={2}>things to keep in mind for the upcoming event</Typography>
        </Grid>
      </Grid>

      <SimpleCard variant="outlined">
        <Grid container justifyContent="center">
          <Grid item>
            <Typography fontWeight="bold">Check in:</Typography>
          </Grid>
          <Grid item>
            <Typography marginLeft={2}>
              Starts at {formatTime(event?.parameters_event.hour_start_event)}
            </Typography>
          </Grid>
        </Grid>
        {/* <Grid container justifyContent="center">
          <Grid item>
            <Typography>meet your venue host at the blue tent marked on the map</Typography>
          </Grid>
        </Grid>
        <Grid container marginY={5} justifyContent="center">
          <Grid item>
            <Typography fontWeight="bold">Remember to bring with you:</Typography>
            <Typography>A valid drivers license, or other official photo ID</Typography>
            <Typography>A space charger (this venue comes with the outlets!)</Typography>
            <Typography>A square reader, or another form of electronic payment</Typography>
          </Grid>
        </Grid> */}
        <Grid container justifyContent="center">
          <Grid item>
            <Typography fontWeight="bold">Got it!</Typography>
            <Typography fontWeight="bold">
              If you have any questions, check out the event page
            </Typography>
          </Grid>
        </Grid>
      </SimpleCard>
    </div>
  );
}
